"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    organization: 'Organisation' || 'organization',
    createSupplierAndOrganisation: 'Skapa leverantörsorganisation med användare' ||
        'createSupplierAndOrganisation',
    publishOnQvanti: 'Publicera på Qvanti' || 'publishOnQvanti',
    unpublishOnQvanti: 'Avpublicera från Qvanti' || 'unpublishOnQvanti',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    name: 'Organisationsnamn' || 'name',
    organizationNumber: 'Organisationsnummer' || 'organizationNumber',
    subscriptionLevel: 'Typ av prenumeration' || 'subscriptionLevel',
    subscriptionLevels: {
        basic: 'Qvanti Supplier Basic' || 'basic',
        flaivy: 'Qvanti Supplier' || 'flaivy',
        flaivyplus: 'Qvanti Supplier+' || 'flaivyplus',
        enterprise: 'Qvanti Supplier Enterprise' || 'enterprise',
    },
    emailForPurchaseOrder: 'E-post för inleverans' || 'emailForPurchaseOrder',
    usesSupplierCustomer: 'Har eget kundregister' || 'usesSupplierCustomer',
    usesOrganizationProductCategories: 'Har egna produktkategorier' || 'usesOrganizationProductCategories',
    shouldFlaivyGenerateOrderNumbers: 'Flaivy genererar ordernummer' || 'shouldFlaivyGenerateOrderNumbers',
    shouldFlaivyGenerateArticleNumbers: 'Flaivy genererar artikelnummer' || 'shouldFlaivyGenerateArticleNumbers',
    isPublished: 'Kan kund begära kundkoppling' || 'isPublished',
    qvantiId: 'Leverantörens identitet i Qvanti' || 'qvantiId',
    defaultOrderFullfillmentCenter: 'Leveranslager' || 'defaultOrderFullfillmentCenter',
    GLNNumber: 'GLN-nummer' || 'GLNNumber',
    ourCustomerNumber: 'Flaivys kundnummer' || 'ourCustomerNumber',
    isUsingCrm: 'Leverantören använder CRM' || 'isUsingCrm',
    hasCopackAgreement: 'Har copack-avtal' || 'hasCopackAgreement',
    active: 'Aktiv' || 'active',
    zipCodeToOfcMaps: {
        id: 'id' || 'id',
        zipCodeStart: 'Postnummer från och med' || 'zipCodeStart',
        zipCodeEnd: 'Postnummer till och med' || 'zipCodeEnd',
        orderFullfillmentCenter: 'Leveranslager' || 'orderFullfillmentCenter',
    },
    organizationCustomFields: {
        id: 'id' || 'id',
        entityType: 'Entitetsnamn' || 'entityType',
        entityTypes: {
            article: 'Artikel' || 'article',
            order: 'Order' || 'order',
            supplier: 'Leverantör' || 'supplier',
            supplierCustomer: 'Leverantörskund' || 'supplierCustomer',
            purchaseOrder: 'Inleverans' || 'purchaseOrder',
            invoice: 'Faktura' || 'invoice',
            priceList: 'Prislista' || 'priceList',
            settlement: 'Avräkning' || 'settlement',
        },
        fieldType: 'Datatyp' || 'fieldType',
        fieldTypes: {
            string: 'Sträng' || 'string',
            select: 'Select' || 'select',
            number: 'Nummer' || 'number',
            boolean: 'Boolean' || 'boolean',
            date: 'Datum' || 'date',
        },
        selectOptions: 'Fältnamn' || 'selectOptions',
        name: 'Fältnamn' || 'name',
        localizedName: 'Namn som ses i gränssnittet' || 'localizedName',
    },
};
